module.exports = __webpack_public_path__ + "static/media/client-on.a0452b5a.svg";